/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiApp } from 'api/request';
import urlApp from 'api/urlApp';
import { size } from 'lodash';
import HttpRequestError from 'utils/HttpRequetsError';

export async function getOrderPrintHashApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getOrderPrintHashPath, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getInfoPrintOrderApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getInfoOrderPrintPath, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}